<template>
  <NuxtLink
    class="navigation-logo"
    :class="{ 'navigation-logo--transparent': isTransparent }"
    :to="localePath('/')"
  >
    <span class="sr-only">Link to home page</span>
    <span class="navigation-logo__icons">
      <BaseIconSvg
        name="logo"
        class="navigation-logo__icon"
        :class="{ 'navigation-logo__icon--hidden': isWhite }"
        aria-hidden="true"
      />
      <BaseIconSvg
        name="infermedica-logo-white"
        class="navigation-logo__icon navigation-logo__icon--overlay"
        :class="{ 'navigation-logo__icon--hidden': !isWhite }"
        aria-hidden="true"
      />
    </span>
  </NuxtLink>
</template>
<script lang="ts" setup>
interface Props {
  isWhite?: boolean
  isTransparent?: boolean
}
defineProps<Props>()
const localePath = useLocalePath()
</script>

<style lang="scss" scoped>
.navigation-logo {
  color: inherit;
  background: none;

  &:hover {
    color: inherit;
    text-decoration: none;
  }

  &__icons {
    position: relative;
    display: block;
    width: 160px;
    height: 32px;
  }

  :deep(.logomark-plus) {
    transition: opacity 0.35s ease;
  }

  &__icon {
    color: inherit;
    display: grid;
    place-items: center;
    width: 160px;
    height: 32px;
    overflow: visible;
    transition: opacity 0.3s ease;

    &--overlay {
      position: absolute;
      inset: 0;
    }

    &--hidden {
      opacity: 0;
      pointer-events: none;
    }
  }

  &--transparent {
    :deep(.logomark-plus) {
      opacity: 0;
    }
  }
}
</style>
